import angular from 'angular';

(function() {
    'use strict';
    angular.module('indexfile').factory('IndexFilesFilter', IndexFilesFilterData);

    IndexFilesFilterData.$inject = ['INDEX_FILE_STATUS'];

    /* @ngInject */
    function IndexFilesFilterData(INDEX_FILE_STATUS) {
        IndexFilesFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch
        };

        function IndexFilesFilter(indexFilesFilterData) {
            if (!indexFilesFilterData) {
                this.buildEmpty();
            } else {
                this.build(indexFilesFilterData);
            }
        }

        return IndexFilesFilter;

        function buildEmpty() {
            this.batchId = null;
            this.ladProviderId = null;
            this.indexStatus = INDEX_FILE_STATUS[2];
            this.reference = null;
            this.dateFrom = null;
            this.dateTo = null;
            this.timeFrom = initialTimeFrom();
            this.timeTo = initialTimeTo();
        }

        function build(indexFilesFilterData) {
            this.batchId = indexFilesFilterData.batchId || null;
            this.ladProviderId = indexFilesFilterData.ladProviderId;
            this.indexStatus = indexFilesFilterData.indexStatus || INDEX_FILE_STATUS[2];
            this.reference = indexFilesFilterData.fileName || null;
            this.dateFrom = indexFilesFilterData.dateFrom || null;
            this.dateTo = indexFilesFilterData.dateTo || null;
            this.timeFrom = indexFilesFilterData.timeFrom || initialTimeFrom();
            this.timeTo = indexFilesFilterData.timeTo || initialTimeTo();
        }

        function preparBeforeSearch() {
            var clone = new IndexFilesFilter(this);
            if (clone.indexStatus === INDEX_FILE_STATUS[0]) {
                clone.status = null;
            } else {
                clone.status = clone.indexStatus.key;
            }
            if (this.dateFrom) {
                clone.receptionDateFrom = new Date(
                    clone.dateFrom.getFullYear(),
                    clone.dateFrom.getMonth(),
                    clone.dateFrom.getDate(),
                    clone.timeFrom.getHours(),
                    clone.timeFrom.getMinutes()
                );
            }
            if (this.dateTo) {
                clone.receptionDateTo = new Date(
                    clone.dateTo.getFullYear(),
                    clone.dateTo.getMonth(),
                    clone.dateTo.getDate(),
                    clone.timeTo.getHours(),
                    clone.timeTo.getMinutes()
                );
            }
            delete clone.dateFrom;
            delete clone.dateTo;
            delete clone.timeFrom;
            delete clone.timeTo;
            delete clone.indexStatus;
            return clone;
        }

        function initialTimeFrom() {
            var time = new Date();
            time.setHours(0, 0, 0, 0);
            return time;
        }

        function initialTimeTo() {
            var time = new Date();
            time.setHours(23, 59, 0, 0);
            return time;
        }
    }
})();
